import React from "react";

import Layout from "./Layout";

const ContentCarousel = props => <Layout {...props} type="ContentCarousel" />;

export default ContentCarousel;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/ContentCarouselContainer.js